import React from 'react';
import '../../Common/Custom.css';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import CallIcon from '@mui/icons-material/Call';

import ScanVerification from '../../Common/ScanVerification';
import PageTabs from '../../Common/PageTabs';


 
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow:'none',
}));





function Serialnumber() {
  return <div><div className="verify-product">
      <div className="product-box">
       <Card className='card-box'>
          <ScanVerification allowSearch={true} autoVerify={false} />

          <Card className='inner-card mb-10'>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Item>
              <div className='helplinetitle'>Helpline For Any Query  <a href="tel:1800-102-8397"><CallIcon/> 1800-102-8397</a></div>

              </Item>
            </Grid>
          </Grid>
          </Card>


       </Card>

       <PageTabs buyHref="https://ananda.in/product/rich-paneer/" showConnect={false} />

      </div>
    </div>
    </div>;
}


export default Serialnumber;
